import { getMenuList } from "@/lib/menu-config.ts";
import { breadcrumbFactory } from "@/lib/breadcrumb-factory.ts";
import type { BreadcrumbLabels } from "@/types/breadcrumb.ts";

export const useMenuLabel = (pathname: string): BreadcrumbLabels => {
  // 동적 브레드크럼 팩토리 확인
  const dynamicLabels = breadcrumbFactory.getLabels(pathname);
  if (dynamicLabels) {
    return dynamicLabels;
  }

  // 기존 메뉴 설정에서 찾기
  const menuList = getMenuList();

  const currentMenu = menuList.find((menu) =>
    Array.isArray(menu.children) && menu.children.length > 0
      ? menu.children.some((child) => child.path === pathname)
      : menu.path === pathname
  );

  const currentLabel: string = currentMenu?.children?.length
    ? currentMenu.children.find((child) => child.path === pathname)?.label ?? ""
    : currentMenu?.label ?? "";

  const parentLabel = currentMenu?.label ?? "";

  if (currentLabel === parentLabel) {
    return { currentLabel };
  }

  return { currentLabel, parentLabel };
};